import { PolicyTranformService } from './policytransform.service'
import { PolicyService } from './policy.service'
export const PROVIDERS = [PolicyTranformService, PolicyService];